module.exports = __webpack_public_path__ + "img/icon-stage-blue.18eb63ee.png";